import { useEffect, useState } from "react";
import { CheckCircle, XCircle } from "lucide-react";
import axios from "axios";
import {
  Container,
  AnimationContainer,
  OuterGear,
  Content,
  InnerGear,
  CenterIcon,
  BouncingIcon,
  StatusText,
  Title,
  Subtitle,
  PulsingIcon,
} from "./style";
import Gear from "./components/gear";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
export default function PaymentProcessing() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [error, setError] = useState<any>();
  console.log(JSON.stringify(error, null, 2));
  const { method, refId, requestId } = useParams();
  const navigate = useNavigate();
  const processPayment = async (data: any) => {
    await axios({
      method: "post",
      url: `${process.env.APP_BASE_URL}/payment-requests/verify`,

      data,
      headers: {
        "Api-Key": process.env.API_KEY,
      },
    })
      .then((response) => {
        setIsLoading(false);
        setIsSuccess(true);
        navigate(
          `/payment-status/${method}/${refId}/${requestId}/success?status=success`,
        );
      })
      .catch((error) => {
        console.error("Payment verification error:", error);
        const errorData = error.response?.data || {
          message: error.message || "Unknown error",
        };
        setError(errorData);
        setIsLoading(false);
        navigate(
          `/payment-status/${method}/${refId}/${requestId}/failed?status=failed`,
          { state: { error: errorData } },
        );
      });
  };

  useEffect(() => {
    processPayment({
      method,
      refId,
      requestId,
    });
  }, []);

  return (
    <Container>
      {error && <pre>{JSON.stringify(error, null, 2)}</pre>}
      <Content>
        <AnimationContainer>
          <OuterGear loading={isLoading}>
            <Gear teeth={12} radius={80} color={"#f23236"} />
          </OuterGear>
          <InnerGear loading={isLoading}>
            <Gear teeth={12} radius={60} color={"#f23236"} />
          </InnerGear>
          <CenterIcon loading={isLoading}>
            {!isLoading && !!isSuccess && (
              <BouncingIcon>
                <CheckCircle size={64} color="#1B9742" />
              </BouncingIcon>
            )}
            {!isLoading && !isSuccess && (
              <PulsingIcon>
                <XCircle size={64} color="#f23236" />
              </PulsingIcon>
            )}
          </CenterIcon>
        </AnimationContainer>

        <StatusText>
          {!!isLoading && (
            <>
              <Title color="#000" animate>
                Processing Payment...
              </Title>
              <Subtitle color="#000">
                Please wait while we secure your transaction
              </Subtitle>
            </>
          )}
          {!isLoading && !!isSuccess && (
            <>
              <Title color="#1B9742">Payment Successful!</Title>
              <Subtitle color="#1B9742">
                Your transaction has been completed
              </Subtitle>
            </>
          )}
          {!isLoading && !isSuccess && (
            <>
              <Title color="#f23236">Payment Failed 😔</Title>
              <Subtitle color="#f23236">
                Please try again or contact support
              </Subtitle>
            </>
          )}
        </StatusText>
      </Content>
    </Container>
  );
}
